;(function () {
    new Vue({
            el: "#cio-watch",
            data: {
                mainVideo: {
                    cover:'',
                    title:'',
                    videoUrl:'',
                }, // 唯一字段已经注册过
                isPlay: false,
                videoList: [
                    {
                        cover:'/static/pc/img/campaign/fod/cio-videio-cover-1.jpg',
                        title:'CIO观察家第一期',
                        videoUrl:'https://dellvideo.smarket.net.cn/ef09cb0e71464727916559aa90602a1a/e548119074284f15b9ada41144f561d9-8905aa59d1f1f1535bf786a6d1ce359d-ld.mp4',
                    },
                    {
                        cover:'/static/pc/img/campaign/fod/cio-videio-cover-2.jpg',
                        title:'CIO观察家第二期',
                        videoUrl:'https://dellvideo.smarket.net.cn/88fc9153472d446ebef93d78e13adc06/14953c14930743b086e9b11e2df51aee-328cdef9d09c3af3dfe42fd2b94364e3-ld.mp4',
                    },
                    {
                        cover:'/static/pc/img/campaign/fod/cio-videio-cover-3.jpg',
                        title:'CIO观察家第三期',
                        videoUrl:'https://dellvideo.smarket.net.cn/f7de889f05234442800171fc9c7bb800/b31a3f584a73448aa11f64e8e04190ff-b8af538f0e94fa64688cc0e4e2f3db21-ld.mp4',
                    },
                    {
                        cover:'/static/pc/img/campaign/fod/cio-videio-cover-4.jpg',
                        title:'CIO观察家第四期',
                        videoUrl:'https://dellvideo.smarket.net.cn/7da67f86bbdf48d28f6799df0befd10a/5737d865401549f294d5aea5e4d72fae-90f1f43ae584bc0096eb8c7716672049-ld.mp4',
                    },
                    {
                        cover:'/static/pc/img/campaign/fod/cio-videio-cover-5.jpg',
                        title:'CIO观察家第五期',
                        videoUrl:'https://dellvideo.smarket.net.cn/0065a669d1b746a9a2f7cf1726731a4a/4f418dab13154afa9f29128867f563b9-8ffcf420c2e1758cb00d64176800f404-ld.mp4',
                    }
                ]
            },

            created: function () {
                this.mainVideo = this.videoList[0];
            },

            mounted: function() {

                if(!common.isM){
                    $('#cio-video-list').niceScroll({
                        cursorcolor: "#0076ce",
                        background: "rgba(255,255,255,.5)",
                        cursoropacitymax: 1,
                        touchbehavior: false,
                        cursorwidth: "8px",
                        cursorborder: "0",
                        cursorborderradius: "0",
                        autohidemode: false
                    });
                }else{
                    new Swiper('.cio-video-list-swiper-container', {
                        //autoplay: true,//可选选项，自动滑动
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                    })
                }
            },
            methods: {
                changeMainVideo: function (item) {
                    this.isPlay = false;
                    this.mainVideo = item;
                },

                play: function () {
                    this.isPlay = true;
                }
            }
        }
    )
})();
